import { InfoTooltip } from "@/components/WTooltip.tsx";
import { t_uefiWarning } from "@/modules/compute/labels.tsx";
import type { BootFirmware } from "@warrenio/api-spec/spec.oats.gen";
import { exhaustiveSwitchCheck } from "@warrenio/utils/unreachable";

/** Display the boot mode (firmware) of a VM. Defaults to BIOS when unset. */
export function BootMode({ value }: { value: BootFirmware | null | undefined }) {
    switch (value) {
        case "uefi":
            return <InfoTooltip text={t_uefiWarning}>UEFI</InfoTooltip>;
        case "bios":
        case null:
        case undefined:
            return "BIOS";
        default:
            return exhaustiveSwitchCheck(value);
    }
}
